import * as _ from 'lodash'
import moment from 'moment'
import tippy from 'tippy.js'
import 'tippy.js/dist/tippy.css'


const meta = 'dashboard'
window[`fnc_${meta}`] = initDashboardPage

document.addEventListener("loadPage", () => {
    const evMeta = document.querySelector('meta[name="eventListener"]')
    if (evMeta !== null && evMeta['content'] === meta) {
        document.addEventListener("appReady", () => {
            if (DEBUG) console.log((`Initializing ${meta} page`))
            window[`fnc_${meta}`]()
        })
    }
})

async function initDashboardPage() {
    $('#loading-animation').removeClass('visually-hidden')
    $('.row.widget-container').each(function (idx, obj) {
        $(this).addClass('visually-hidden')
    })

    const period = helpers.appSettingsGet('dashboardPeriod') !== null ? moment(helpers.appSettingsGet('dashboardPeriod')).toISOString() : moment().toISOString()

    const options1: Intl.DateTimeFormatOptions = {
        month: "long",
        year: "numeric"
    }

    const options2: Intl.DateTimeFormatOptions = {
        year: "numeric"
    }
    
    $('#dashboard-period').text(helpers.ucFirst( new Intl.DateTimeFormat(globals.vars.locales, options1).format(new Date(period)) ))
    $('#dashboard-widget-m').text(helpers.ucFirst( new Intl.DateTimeFormat(globals.vars.locales, options1).format(new Date(period)) ))
    $('#dashboard-widget-l').text(helpers.ucFirst( new Intl.DateTimeFormat(globals.vars.locales, options1).format(new Date(moment(period).subtract(1, 'month').toISOString())) ))
    $('#dashboard-widget-y').text(helpers.ucFirst( new Intl.DateTimeFormat(globals.vars.locales, options2).format(new Date(period)) ))


    if (moment(period).endOf('month') < moment()) {
        $('#period-next').removeAttr('disabled')
        $('#period-reset').removeClass('visually-hidden')

        $('#dashboard-widget-w').closest('.widget').addClass('visually-hidden')
        $('.widget').removeClass('col-xl-3').addClass('col-xl-4')
    } else {
        $('#period-next').attr('disabled')
        $('#period-reset').addClass('visually-hidden')
  
        $('#dashboard-widget-w').closest('.widget').removeClass('visually-hidden')
        $('.widget').removeClass('col-xl-4').addClass('col-xl-3')
    }
    
    $('#period-prev').off().on('click', function(e) {
        helpers.appSettingsSet({'dashboardPeriod': moment(period).subtract(1, 'month').toISOString()})
        setTimeout(initDashboardPage, 100)
    })
    
    $('#period-next').off().on('click', function(e) {
        helpers.appSettingsSet({'dashboardPeriod': moment(period).add(1, 'month').toISOString()})
        setTimeout(initDashboardPage, 100)
    })
    
    $('#period-reset').off().on('click', function(e) {
        helpers.appSettingsDelete('dashboardPeriod')
        setTimeout(initDashboardPage, 100)
    })

    const params = {
        sMonth: moment(period).toISOString(),
        _csrf: $("meta[name=_csrf]").attr("content")
    }

    $.ajax({
        url: '/json/dashboard',
        method: 'POST',
        data: params,
        success: function (response) {  
            if (DEBUG) console.log(response)

            //ANCHOR Accounts Balances
            const accounts = {}

            _.map(response['accounts'], function(o) {
                const aType = o.custom_cashAccountType !== '' ? o.custom_cashAccountType : global.i18n.t('dashboard.empty_accountType')

                if (typeof accounts[aType] === 'undefined')
                    accounts[aType] = { result: {}, data: [] }

                accounts[aType]['data'].push(o)

                if (typeof accounts[aType]['result'][o.currency] === 'undefined')
                    accounts[aType]['result'][o.currency] = 0

            })

            /** Calculating global balances per account type **/
            let _out1 = ''

            for (const k in accounts) {
                _.map(accounts[k]['data'], function(o) {
                    const bal = _.filter(o.data.balances, function(p) {
                        return p.balanceType === 'calculated'
                    })[0]

                    if (o.statistic)
                        accounts[k]['result'][o.currency] += parseFloat(bal['balanceAmount']['amount'])
                })

                let total = []

                for (const c in accounts[k]['result']) {
                    const _a = helpers.anonFigures( helpers.fmtCurrency(parseFloat(accounts[k]['result'][c].toFixed(2)), c) )

                    const cls = parseFloat(accounts[k]['result'][c]) >= 0 ? 'text-success' : 'text-danger'

                    total.push(`<span class="${cls} amount fs-4 m-0 p-0">${_a}</span>`)

                }

                _out1 += `
                    <div class="float-end fw-bold">
                        ${ total.join(", ") }
                    </div>

                    <h4 class="header-title fs-4">${k}</h4>

                    <div class="table-responsive mt-2 mb-3">
                        <table class="table table-sm mb-0">
                            <tbody>`

                for (let i=0; i<accounts[k]['data'].length; i++) {
                    const item = accounts[k]['data'][i]

                    const bal = _.filter(item.data.balances, function(p) {
                        return p.balanceType === 'calculated'
                    })[0]

                    let expected_bal = null
                    
                    for (let j=0; j<item.data.balances.length; j++) {
                        if (item.data.balances[j].balanceType == 'expected') {
                            expected_bal = item.data.balances[j].balanceAmount
                            break
                        } else if (item.data.balances[j].balanceType == 'closingBooked') {
                            expected_bal = item.data.balances[j].balanceAmount
                            break
                        } else if (item.data.balances[j].balanceType == 'interimAvailable') {
                            expected_bal = item.data.balances[j].balanceAmount
                            break
                        }
                    }
                  
                    let _a = helpers.anonFigures( helpers.fmtCurrency(parseFloat(bal['balanceAmount']['amount']), item.currency) )

                    if (!item.statistic)
                        _a = `(${_a})`

                    let _b = expected_bal === null || parseFloat(bal['balanceAmount']['amount']) == parseFloat(expected_bal['amount']) ? _a : `<span class="text-nowrap" data-plugin="tippy" data-tippy-placement="left" data-tippy="" data-tippy-allowHTML="true" data-tippy-content="<i class='far fa-clock'></i> ${helpers.anonFigures( helpers.fmtCurrency(parseFloat(expected_bal['amount']), item.currency) )}"><i class="far fa-clock text-muted"></i> ${_a}</span>`

                    const cls = parseFloat(bal['balanceAmount']['amount']) >= 0 ? 'text-success' : 'text-danger'

                    _out1 += `
                            <tr class="d-flex account-sel" data-account="${item._id}">
                                <th scope="row"><img src="${_.isEmpty(item.institution_data) ? 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=' : item.institution_data[0].logo}" style="height: 20px; width: auto"></th>
                                <td class="flex-grow-1">${ item.custom_name !== '' ? item.custom_name : item.name}</td>
                                <td class="d-flex ${cls} justify-content-end amount fs-5">${_b}</td>
                            </tr>
                    `
                }

                _out1 += `          
                            </tbody>
                        </table>
                    </div>
                `
            }

            $('#dash-summary').html(_out1)
            $('#dash-cur-bal').html(`${global.i18n.t('accounts.account_balance', {count: Object.keys(accounts).length})} (${new Date().toLocaleDateString(globals.vars.locales)})`)

            //ANCHOR account click
            $('.account-sel').each(function (idx, obj) {
                $(this).off().on('dblclick', (e) => {
                    e.preventDefault()
                    e.stopPropagation()

                    window.getSelection().removeAllRanges()

                    helpers.appSettingsDelete('transactionsCategoryFilter')
                    helpers.appSettingsDelete('transactionsFilters')
                    helpers.appSettingsSet({'transactionsStartTime': moment().startOf('month').toISOString()})
                    helpers.appSettingsSet({'transactionsEndTime': moment().endOf('month').toISOString()})
                    helpers.appSettingsDelete('transactionsUntilToday')

                    helpers.appSettingsSet({'transactionsAccountId': $(this).attr('data-account')})
            
                    if (!globals.vars.userData.accountsById[$(this).attr('data-account')]['favorite'])
                        helpers.appSettingsSet({'transactionsFavoriteAccountsOnly': false})
                    
                    window.location.href = '/transactions'
                })
            })


            //ANCHOR Savings Rate
            /** default view **/
            const _months = []

            for (let i=11; i>=0; i--) {
                const p = moment(period).subtract(i, 'month').format('YYYY-MM')
                _months.push(moment(period).subtract(i, 'month').format('YYYY-MM'))

            }

            const _validMonths = _.map(response['revenues']['savings'], function(o) {
                return o['period'].substring(0,7)
            })

            let savings_avg = 0

            let _out2 = ''

            for (let i=0; i<_months.length; i++) {
                const period = _months[i]

                if (_validMonths.includes(period)) {
                    const _v = _.filter(response['revenues']['savings'], function(o) {
                        return o['period'].substring(0,7) === period
                    })[0]

                    const percent = _v['percent']

                    savings_avg += percent

                    const cls = percent >= 0 ? 'text-success' : 'text-danger'

                    const sm = i < 6 ? 'd-none d-sm-block' : ''

                    const bold = i == _months.length -1 ? ' fw-bold' : ''

                    _out2 += `
                        <div class="flex-fill justify-content-center ${sm}">
                            <p class="m-0 text-muted${bold}">${helpers.ucFirst(moment(period).format('MMM').replace(/\./, ""))}</p>
                            <p class="m-0 ${cls}${bold} amount">${percent == 0 ? '-' : helpers.anonFigures(new Intl.NumberFormat(globals.vars.locales, { minimumFractionDigits: 1, maximumFractionDigits: 1, style: "percent" }).format(percent))}</p>
                        </div>
                    `
                } else {
                    /** create empty entry **/
                    _out2 += `
                        <div class="flex-fill justify-content-center">
                            <p class="m-0 text-muted">${helpers.ucFirst(moment(period).format('MMM').replace(/\./, ""))}</p>
                            <p class="m-0 amount">-</p>
                        </div>
                    `
                }
            }

            $('#savings').html(_out2)

            savings_avg = savings_avg / response['revenues']['savings'].length // savings contains only valid months

            const clss = savings_avg >= 0 ? 'text-success' : 'text-danger'

            const prefx = savings_avg > 0 ? '+': ''

            $('#savings-pct').text(helpers.anonFigures(prefx+new Intl.NumberFormat(globals.vars.locales, { minimumFractionDigits: 2, maximumFractionDigits: 2, style: "percent" }).format(savings_avg)+global.i18n.t('dashboard.widgets.savings_avg')))
            $('#savings-pct').addClass(clss)

            //ANCHOR WIDGETS
            if (typeof response['revenues']['this_week'] !== 'undefined') {    
                if (!isNaN(response['revenues']['this_week']['income']))
                    $('#stats-si').text(helpers.anonFigures( helpers.fmtCurrency(response['revenues']['this_week']['income'], 'EUR') ))

                if (!isNaN(response['revenues']['this_week']['expenses']))
                    $('#stats-se').text(helpers.anonFigures( helpers.fmtCurrency(response['revenues']['this_week']['expenses'], 'EUR') ))
            }

            if (typeof response['revenues']['this_month'] !== 'undefined') {    
                if (!isNaN(response['revenues']['this_month']['income']))
                    $('#stats-mi').text(helpers.anonFigures( helpers.fmtCurrency(response['revenues']['this_month']['income'], 'EUR') ))

                if (!isNaN(response['revenues']['this_month']['expenses']))
                    $('#stats-me').text(helpers.anonFigures( helpers.fmtCurrency(response['revenues']['this_month']['expenses'], 'EUR') ))

                if (!isNaN(response['revenues']['this_month']['profit'])) {
                    $('#stats-mr').text(helpers.anonFigures( helpers.fmtCurrency(response['revenues']['this_month']['profit'], 'EUR') ))

                    if (parseFloat(response['revenues']['this_month']['profit']) >= 0)
                        $('#stats-mr').removeClass('text-danger').addClass('text-success')
                    else
                        $('#stats-mr').removeClass('text-success').addClass('text-danger')
                }
            }

            if (typeof response['revenues']['last_month'] !== 'undefined') {   
                if (!isNaN(response['revenues']['last_month']['income']))
                    $('#stats-mdi').text(helpers.anonFigures( helpers.fmtCurrency(response['revenues']['last_month']['income'], 'EUR') ))

                if (!isNaN(response['revenues']['last_month']['expenses']))
                    $('#stats-mde').text(helpers.anonFigures( helpers.fmtCurrency(response['revenues']['last_month']['expenses'], 'EUR') ))

                if (!isNaN(response['revenues']['last_month']['profit'])) {
                    $('#stats-mdr').text(helpers.anonFigures( helpers.fmtCurrency(response['revenues']['last_month']['profit'], 'EUR') ))

                    if (parseFloat(response['revenues']['last_month']['profit']) >= 0)
                        $('#stats-mdr').removeClass('text-danger').addClass('text-success')
                    else
                        $('#stats-mdr').removeClass('text-success').addClass('text-danger')
                }
            }         

            if (typeof response['revenues']['this_year'] !== 'undefined') {   
                if (!isNaN(response['revenues']['this_year']['income']))
                    $('#stats-yi').text(helpers.anonFigures( helpers.fmtCurrency(response['revenues']['this_year']['income'], 'EUR') ))

                if (!isNaN(response['revenues']['this_year']['expenses']))
                    $('#stats-ye').text(helpers.anonFigures( helpers.fmtCurrency(response['revenues']['this_year']['expenses'], 'EUR') ))

                if (!isNaN(response['revenues']['this_year']['profit'])) {
                    $('#stats-yr').text(helpers.anonFigures( helpers.fmtCurrency(response['revenues']['this_year']['profit'], 'EUR') ))

                    if (parseFloat(response['revenues']['this_year']['profit']) >= 0)
                        $('#stats-yr').removeClass('text-danger').addClass('text-success')
                    else
                        $('#stats-yr').removeClass('text-success').addClass('text-danger')
                }
            } 

            //ANCHOR CATEGORIES
            let categories = response['categories']

            categories = _.map(categories, function(o) {
                o['sum'] = parseFloat(o['income']) + parseFloat(o['expenses']) || 0
                return o
            })

            const _cI = _.filter(categories, function(o) {
                return parseFloat(o['sum']) > 0
            })

            const _cE = _.filter(categories, function(o) {
                return parseFloat(o['sum']) < 0
            })

            const _cSorted = _.orderBy(_cI, ['sum'], ['desc']).concat( _.orderBy(_cE, ['sum'], ['asc']) )

            let output = ''
            let total_rev = 0

            for (let i=0; i<_cSorted.length; i++) {
                const _cat = _cSorted[i]

                total_rev += parseFloat(_cat['sum'])

                let _a = helpers.anonFigures( helpers.fmtCurrency(_cat['sum'], 'EUR') )

                const cls = _cat['sum'] >= 0 ? 'text-success' : 'text-danger'


                const accounts = _.compact(_.map(_cat['accounts'], function(o) {
                    // if (typeof globals.vars.userData.accountsById[o] === 'undefined')
                    //     return null

                    return globals.vars.userData.accountsById[o]['custom_name'] || globals.vars.userData.accountsById[o]['name'] || null
                }))

                const _mark = typeof _cat['_id']['categoryId'] === 'undefined' ? ' bolder text-orange' : ''

                output += `
                        <tr class="drill-to-tr d-flex cat-row" data-category="${_cat['_id']['categoryId']}">
                            <th scope="row" class="text-center justify-content-center" style="width: 22px"><i class="${_cat['_id']['icon']}${_mark}" style="height: 20px; width: auto"></i></th>
                            <td class="flex-grow-1 sTitle">${_cat['_id']['name']}</td>
                            <td class="d-flex ${cls} justify-content-end amount fs-5" data-plugin="tippy" data-tippy-placement="left" data-tippy="" data-tippy-allowHTML="true" data-tippy-content="${accounts.sort().join('<br>')}">${_a}</td>
                        </tr>`
            }

            $('#incexp-table').html(output)

            const cls = total_rev >= 0 ? 'text-success' : 'text-danger'
            $('#cat-rev').text(helpers.anonFigures((total_rev > 0 ? '+' : '')+helpers.fmtCurrency(total_rev, 'EUR') ))
            $('#cat-rev').removeClass('text-danger').removeClass('text-success').addClass(cls)

            tippy('[data-plugin="tippy"]')

            //ANCHOR Category click
            $('.drill-to-tr').each(function (idx, obj) {
                $(this).off().on('dblclick', (e) => {
                    e.preventDefault()
                    e.stopPropagation()

                    window.getSelection().removeAllRanges()

                    helpers.appSettingsSet({'transactionsStartTime': moment(period).startOf('month').toISOString()})
                    helpers.appSettingsSet({'transactionsEndTime': moment(period).endOf('month').toISOString()})
                    helpers.appSettingsSet({'transactionsFavoriteAccountsOnly': false})
                    helpers.appSettingsDelete('transactionsAccountId')

                    if ($(this).closest('tr').attr('data-category') !== 'undefined') {
                        helpers.appSettingsSet({'transactionsCategoryFilter': $(this).closest('tr').attr('data-category')})
                        helpers.appSettingsDelete('transactionsFilters')
                    } else {
                        helpers.appSettingsDelete('transactionsCategoryFilter')
                        helpers.appSettingsSet({'transactionsFilters': ['#filter_uncategorized']})
                    }

                    window.location.href = '/transactions'
                })
            })

            $('#loading-animation').addClass('visually-hidden')
            $('.row.widget-container').each(function (idx, obj) {
                $(this).removeClass('visually-hidden')
            })


        },
        error: function (err) {
            console.log(err)
        }
    })

    $('#incexp-drill-down').off().on('click', function(e) {
        e.preventDefault()
        helpers.appSettingsSet({'reportPeriodIE': period})
        window.location.href = '/reports/income-expenses'
    })
    
}
